import { setTheme } from "theme/default/setTheme";

export const color_93a5b8 = setTheme(({ theme }) => theme.colors.color_93a5b8);
